import { Button, Checkbox, Form, Input, InputNumber, message, Select } from "antd";
import { useEffect, useState } from "react";
import { serverFetch } from "../../../server";
import { CloseOutlined } from "@ant-design/icons";
import { isMobile } from "../../../extensions/design";
import { messagePatternVids } from "./message-pattern-vids";

const defaultItem = { companyId: null, srok: 0, vid: 0, active: true, body: "", name: "" };

const MessagePattern = ({ id, onClose, companies }) => {
  const [item, setItem] = useState(defaultItem);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();

  const companyOptions = [
    { value: null, label: "Общий шаблон" },
    ...(companies ?? []).map((c) => ({ value: c.id, label: c.name })),
  ];

  const getData = () => {
    if (id) {
      setLoading(true);
      serverFetch(`MessagePattern/${id}`)
        .then((data) => {
          setLoading(false);
          setItem(data);
          form.setFieldsValue(data);
        })
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    } else {
      form.setFieldsValue(defaultItem);
      setItem(defaultItem);
    }
  };

  useEffect(getData, [id]);

  const onValuesChange = (value) => {
    setItem({ ...item, ...value });
  };

  const onSave = () => {
    form.validateFields().then(() => {
      setLoading(true);
      const payload = {
        ...item,
        companyId: item.companyId || null,
        srok: item.srok ?? 0,
        vid: item.vid ?? 0,
        active: item.active ?? true,
        body: item.body ?? "",
        name: item.name ?? "",
      };
      if (id) {
        payload.id = id;
      }
      const method = id ? "PUT" : "POST";
      serverFetch("MessagePattern", { method, bodyData: payload })
        .then(() => onClose(true))
        .catch((e) => {
          setLoading(false);
          message.error(e.userMessage);
        });
    });
  };

  const onDelete = () => {
    if (!id) return;
    setLoading(true);
    serverFetch(`MessagePattern/${id}`, { method: "DELETE" })
      .then(() => onClose(true))
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  const onCheck = () => {
    if (!id) {
      message.warning("Сначала сохраните шаблон");
      return;
    }
    setLoading(true);
    serverFetch(`MessagePattern/check/${id}`, { method: "POST" })
      .then(() => {
        setLoading(false);
        message.success("Тестовое сообщение отправлено");
      })
      .catch((e) => {
        setLoading(false);
        message.error(e.userMessage);
      });
  };

  return (
    <div className="sport-modal">
      <div className="sport-modal-overlay" onMouseDown={(e) => e.target === e.currentTarget && onClose(false)}>
        <div className={isMobile ? "sport-modal-content mobile-content" : "sport-modal-content"} style={isMobile ? {} : { width: 800 }} onMouseDown={(e) => e.stopPropagation()}>
          <div className={isMobile ? "sport-modal-title-client" : "sport-modal-title"}>
            <span>{id ? "Шаблон сообщения" : "Новый шаблон"}</span>
            <CloseOutlined
              className="sport-section-title-close"
              onClick={() => onClose(false)}
              style={{ zIndex: 9, color: "#2f6f00", fontSize: 16 }}
            />
          </div>
          <Form form={form} layout="vertical" onValuesChange={onValuesChange}>
            <Form.Item name="name" label="Имя" rules={[{ required: true, message: "Введите имя" }]}>
              <Input placeholder="Название шаблона" />
            </Form.Item>
            <Form.Item name="companyId" label="Компания">
              <Select options={companyOptions} placeholder="Общий шаблон" allowClear />
            </Form.Item>
            <Form.Item name="vid" label="Момент запуска" rules={[{ required: true }]}>
              <Select options={messagePatternVids} />
            </Form.Item>
            <Form.Item name="srok" label="Дней до/после события">
              <InputNumber min={0} style={{ width: "100%" }} />
            </Form.Item>
            <Form.Item name="body" label="Текст шаблона" rules={[{ required: true, message: "Введите текст" }]}>
              <Input.TextArea rows={5} placeholder="Текст с плейсхолдерами {{name}}, {{days}} и т.д." />
            </Form.Item>
            <Form.Item name="active" valuePropName="checked">
              <Checkbox>Активен</Checkbox>
            </Form.Item>
            <div style={{ display: "flex", justifyContent: "space-between", marginTop: 16 }}>
              <div>
                {id && (
                  <Button danger onClick={onDelete} loading={loading}>
                    Удалить
                  </Button>
                )}
              </div>
              <div style={{ display: "flex", gap: 8 }}>
                <Button onClick={onCheck}>Проверка</Button>
                <Button onClick={() => onClose(false)}>Отмена</Button>
                <Button type="primary" onClick={onSave} loading={loading}>
                  Сохранить
                </Button>
              </div>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default MessagePattern;
